import { ActiveNoteData, ActiveNotesModalGridFields } from './constants'
import { loadClientNotes, loadClientLinkedFiles } from 'src/store/client'
import { deleteNote, loanView } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'
import { actions } from '../shared/LKModal'

export const getClientData = async (
  ID: string,
  hash: string,
  dispatch: Function,
): Promise<{ clientNotes: ActiveNotesModalGridFields[]; clientFiles: any[] }> => {
  // const { Data } = await Client.details({
  //   ID,
  //   hash,
  //   page: 'activenotes',
  //   additionalParams: {
  //     ActiveOperFlag: 1,
  //   },
  // } as any)

  //UPDATED API REQUEST client_view_api action:activenotes
  const { payload: Data } = await dispatch(
    loadClientNotes({
      clientId: +ID,
      clientHash: hash,
      additionalParams: {
        ActiveOperFlag: 1,
      },
    }),
  )

  let clientFiles

  if (Data.find((note) => note.LFLID)) {
    // clientFiles = await Client.details({
    //   ID,
    //   hash,
    //   page: 'linkedfiles',
    // } as any).then((res) => res?.Data)

    //UPDATED API REQUEST client_view_api action:linkedfiles
    clientFiles = await dispatch(loadClientLinkedFiles({ clientId: +ID, clientHash: hash })).then((res) => res.payload)
  }

  return await Promise.resolve({
    clientFiles: clientFiles || [],
    clientNotes: [
      ...Data.map(
        (client) =>
          ({
            ...client,
            NT: 'CL',
            CDate: client.OpenDay,
            Type: client.Title,
            Body: client.Comment,
          } as ActiveNotesModalGridFields),
      ),
    ],
  })
}

export const getLoanData = async (
  ID: string,
  hash: string,
  dispatch: Function,
): Promise<{ loanNotes: ActiveNotesModalGridFields[]; loanFiles: any[] }> => {
  // const { Data: loanNotes } = await Loan.loanView({
  //   LoanID: ID,
  //   HashSum_LoanID_: hash,
  //   page: 'reminders',
  //   ActiveOperFlag: 1,
  // })

  //UPDATED API REQUEST loan_view_api page: reminders
  const { payload: loanNotes } = await dispatch(
    loanView({
      LoanID: ID,
      HashSum_LoanID_: hash,
      page: 'reminders',
      ActiveOperFlag: 1,
    }),
  )

  let loanFiles

  // if (loanNotes.find((note) => note.LFLID)) {
  //   loanFiles = await Loan.loanView({
  //     page: 'linkedfiles',
  //     LoanID: ID,
  //     HashSum_LoanID_: hash,
  //   }).then((res) => res?.Data)
  // }

  //UPDATED API REQUEST loan_view_api page: linkedfiles
  if (loanNotes.find((note) => note.LFLID)) {
    loanFiles = await dispatch(
      loanView({
        page: 'linkedfiles',
        LoanID: ID,
        HashSum_LoanID_: hash,
      }),
    ).then(({ payload }) => payload)
  }

  return await Promise.resolve({
    loanFiles: loanFiles || [],
    loanNotes,
  })
}

export const deleteReminder = async (ID: string, LoanID: string, hash: string, dispatch: AppDispatch) => {
  // try {
  //   await Loan.deleteNote({
  //     LoanID,
  //     hash,
  //     ID,
  //   })
  // } catch {}

  //UPDATED API REQUEST loan_oper_post_api page: notedelete
  return dispatch(
    deleteNote({
      LoanID: LoanID,
      HashSum_LoanID_: hash,
      ID: ID,
    }),
  ).then((response) => {
    if (!deleteNote.fulfilled.match(response)) {
      dispatch(actions.openError(response.payload))
      return
    }
    return response.payload
  })
}

export const formatObjectToCommon = (data: Record<string, unknown>): ActiveNoteData => {
  return (
    data &&
    Object.entries(data).reduce((obj, [key, value]) => {
      let changedKey = key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
      if (changedKey === 'hashsumclientid') {
        changedKey = 'clienthash'
      }

      obj[changedKey] = value
      return obj
    }, {} as ActiveNoteData)
  )
}
